<div class='admin'>
  <app-beheer-nav></app-beheer-nav>
  <div class='beheer'>
    <h2>Welkom {{getUsername()}}</h2>
  </div>
</div>